import { useMemo, useState } from 'react';

import PlusButton from '../../_common/elements/PlusButton';
import componentFunctions from '../../../../services/tools/componentFunctions';

import css from './CustomerTable.module.css';
import { Link, useNavigate } from 'react-router-dom';

function CustomerTable({ data, onAdd, service, showModal }) {
    const [filter, setFilter] = useState('');
    const [sortConfig, setSortConfig] = useState(componentFunctions.sortConfig);
    const requestSort = (key) => componentFunctions.requestSort(key, sortConfig, setSortConfig);
    const navigate = useNavigate();

    const sortedAndFilteredData = useMemo(() => {
        return componentFunctions
            .sortedAndFilteredData(data, sortConfig, filter)
            .sort((a, b) => a.customerName.localeCompare(b.customerName));
    }, [data, sortConfig, filter]);

    if (!data || !data.length) {
        return <p>No data available.</p>;
    }

    const headers = Object.keys(data[0]);

    return (
        <>
            <div className={css.control}>
                <input
                    type="text"
                    placeholder="Filter results..."
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    className={css.filterInput}
                />
                <div className={sortedAndFilteredData.length === 0 ? `${css.filterCount} ${css.filterCountZero}` : css.filterCount}>
                    {' '}
                    {sortedAndFilteredData.length}{' '}
                </div>
                <PlusButton onClick={showModal} />
            </div>
            <div style={{ textAlign: 'right', marginTop: '5px', color: 'red', fontSize: '1.2rem' }}>
                {/* <label>
                    Show Completed?
                    <input type="checkbox" onChange={handleShowCompletedFilter} checked={!showCompleted} value={showCompleted} />
                </label> */}
            </div>

            <div className={css.tables}>
                <div>
                    <h3>Corporate</h3>
                    <table className={css.table}>
                        <thead className={css.thead}>
                            <tr>
                                <th onClick={() => requestSort('customerName')} className={css.th}>
                                    Customer
                                    {sortConfig.key === 'customerName' ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                                </th>
                                <th onClick={() => requestSort('customerNameShort')} className={css.th}>
                                    Abbr
                                    {sortConfig.key === 'customerNameShort' ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                                </th>
                                {/* <th className={css.th}>Amount</th> */}
                                <th onClick={() => requestSort('isActive')} className={`${css.th} ${css.center}`}>
                                    Active?
                                    {sortConfig.key === 'isActive' ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                                </th>
                                <th onClick={() => requestSort('customerVat')} className={`${css.th} ${css.center}`}>
                                    VAT
                                    {sortConfig.key === 'customerVat' ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                                </th>

                            </tr>
                        </thead>
                        <tbody className={css.tbody}>
                            {sortedAndFilteredData.length > 0 ? (
                                sortedAndFilteredData
                                    .filter((x) => x.customerType === 'corporate')
                                    .map((item, index) => (
                                        <tr
                                            key={item.customerId}
                                            id={item.customerId}
                                            onClick={() => navigate(`/customer/details/${item.customerId}`)}
                                            className={css.row}
                                        >
                                            <td>{item.customerName}</td>
                                            <td style={{textAlign: 'center'}}>{item.customerNameShort}</td>
                                            <td style={{textAlign: 'center'}}>{item.customerIsActive ? 'Yes' : 'No'}</td>
                                            <td style={{textAlign: 'center'}}>{item.customerVAT}</td>
                                        </tr>
                                    ))
                            ) : (
                                <tr>
                                    <td colSpan={headers.length} style={{ textAlign: 'center' }}>
                                        No matching records found. Please adjust your filter.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div>
                    <h3>Individual</h3>
                    <table className={css.table}>
                        <thead className={css.thead}>
                            <tr>
                                <th onClick={() => requestSort('customerName')} className={css.th}>
                                    Customer
                                    {sortConfig.key === 'customerName' ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                                </th>
                                {/* <th className={css.th}>Amount</th> */}
                                <th onClick={() => requestSort('isActive')} className={`${css.th} ${css.center}`}>
                                    Active?
                                    {sortConfig.key === 'isActive' ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                                </th>
                                <th onClick={() => requestSort('customerVat')} className={`${css.th} ${css.center}`}>
                                    PIN
                                    {sortConfig.key === 'customerVat' ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                                </th>

                            </tr>
                        </thead>
                        <tbody className={css.tbody}>
                            {sortedAndFilteredData.length > 0 ? (
                                sortedAndFilteredData
                                    .filter((x) => x.customerType === 'individual')
                                    .map((item, index) => (
                                        <tr
                                            key={item.customerId}
                                            id={item.customerId}
                                            onClick={() => navigate(`/customer/details/${item.customerId}`)}
                                            className={css.row}
                                        >
                                            <td>{item.customerName}</td>
                                            {/* <td style={{textAlign: 'center'}}>{item.customerNameShort}</td> */}
                                            <td style={{textAlign: 'center'}}>{item.customerIsActive ? 'Yes' : 'No'}</td>
                                            <td style={{textAlign: 'center'}}>{item.customerVAT}</td>
                                        </tr>
                                    ))
                            ) : (
                                <tr>
                                    <td colSpan={headers.length} style={{ textAlign: 'center' }}>
                                        No matching records found. Please adjust your filter.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default CustomerTable;
